import { lambdaGeneralCaller } from '@modules/core/aws/lambdas/lambda-general-caller/lambdaGeneralCaller';
import {
  IUnAuthCredentials,
  IFinalMessageRequest,
  IRejectFinalMessageResponse,
} from './interfaces';

import { AWS_LAMBDAS, AWS_LAMBDAS_OPERATIONS } from '@modules/core/constants';

export default async function rejectFinalMessage(
  request: IFinalMessageRequest,
  rejectionDetail: string
): Promise<boolean> {
  const credentials: IUnAuthCredentials = {
    accessKeyId: process.env.REACT_APP_AWS_UNAUTHENTICATED_ACCESS_KEY_ID || 'NONE',
    secretAccessKey: process.env.REACT_APP_AWS_UNAUTHENTICATED_SECRET_ACCESS_KEY || 'NONE',
  };

  const rejectionResponse = await lambdaGeneralCaller<IRejectFinalMessageResponse>(credentials, {
    FunctionName: AWS_LAMBDAS.reviewFinalMessage,
    Payload: JSON.stringify({
      identityId: request.identityId,
      finalMessageId: request.finalMessageId,
      accessKey: request.accessKey,
      rejectionDetail,
      operation: AWS_LAMBDAS_OPERATIONS.rejectFinalMessage,
    }),
  });

  return rejectionResponse.success;
}
